import { PortableText, PortableTextReactComponents } from "@portabletext/react";

import { Button, Text } from "@/components/elements";

import { Image } from "./Image";
import styles from "./styles.module.css";
import { Video } from "./Video";

const Copy: Partial<PortableTextReactComponents> = {
  block: {
    h1: ({ children }) => (
      <Text as="h1" size="xl" className={styles.h1}>
        {children}
      </Text>
    ),
    h2: ({ children }) => (
      <Text as="h2" size="l" className={styles.h2}>
        {children}
      </Text>
    ),
    h3: ({ children }) => (
      <Text as="h3" size="l" className={styles.h3}>
        {children}
      </Text>
    ),
    normal: ({ children }) => <Text className={styles.p}>{children}</Text>,
  },

  list: {
    bullet: ({ children }) => {
      return <ul>{children}</ul>;
    },
    number: ({ children }) => {
      return <ol>{children}</ol>;
    },
  },

  listItem: {
    bullet: ({ children }) => <li>{children}</li>,
    number: ({ children }) => <li>{children}</li>,
  },

  types: {
    imageSection: Image,
    youtubeSection: Video,
    ctaLink: ({ value }) => {
      return (
        <div className={styles.link}>
          <Button theme="green" href={value.href}>
            {value.text}
          </Button>
        </div>
      );
    },
  },
};

export const ArticleBody = ({ value }) => (
  <section className={styles.copy}>
    <PortableText value={value} components={Copy} />
  </section>
);
